/*
 * @Description: vr专区每一个轮播小块
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-10 09:22:12
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-15 14:15:58
 */
import React, { useEffect } from 'react' ;
import { Log } from '../../util/empty' ;

const SelfVr = (props) => {
  const addempty = () => {
    Log(`cfVREntryClick`);
  }
  return(
    <div className="selfvr-block swiper-slide" onClick={addempty}>
      <div className="selfvr-block-titleImg" style={{background : `url(${props.data.cover}) no-repeat`,backgroundSize:"cover"}}>
        <a href={`//qy.m.58.com/vr/${props.data.uid}`} target="_blank"></a>
      </div>
      <div className="selfvr-block-intro">
        <div className="selfvr-block-intro-left" style={{background:`url(${props.data.logo}) no-repeat`,backgroundSize : "contain",backgroundPosition:"center"}}></div>
        <div className="selfvr-block-intro-right">
          <p><a href={`//qy.m.58.com/vr/${props.data.uid}`} target="_blank">{props.data.name}</a></p>
          <div className="selfvr-company-intro">{props.data.industry}</div>
        </div>
      </div>
    </div>
  )
}

export default SelfVr ;